import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(config).apiMethod({
                method: 'AllocateEntries',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: payload.allocation,
                urlArgs: {
                    sweepstake_id: payload.sweepstake_id ? payload.sweepstake_id : '',
                    entry_id: payload.entry_id ? payload.entry_id : '',
                },
            });
            return {
                sweepId: payload.sweepstake_id ? payload.sweepstake_id : '',
                entryId: payload.entry_id ? payload.entry_id : '',
                submitted: true,
                error: result.code ? true : false,
                data: result,
            };
        }
    };
};
